export class AnalyzerInfoDataInputParameters {
    constructor(dataX, interestRate, paperPositions, optionCalculator) {
        this.dataX = dataX;
        this.interestRate = interestRate;
        this.paperPositionsInfo = paperPositions;
        this.optionCalculator = optionCalculator;
    }
}
